<template>
  <filter-base :widthFilter="600" ref="filtroBase">
    <template v-slot:body>
      <el-form
        label-position="top"
        :model="localValue"
        ref="dataFilter"
        class="px-4 py-3"
      >
        <el-form-item class="input-class" prop="codigoPostalOrigen">
          <el-input
            v-model="localValue.codigoPostalOrigen"
            placeholder="Código postal origen"
          ></el-input>
        </el-form-item>
        <el-form-item class="input-class" prop="codigoPostalDestino">
          <el-input
            v-model="localValue.codigoPostalDestino"
            placeholder="Código postal destino"
          ></el-input>
        </el-form-item>
        <el-form-item class="input-class" prop="paisOrigen">
          <div class="row">
            <el-select
              multiple
              class="col"
              v-model="localValue.paisOrigen"
              collapse-tags
              placeholder="País origen"
              filterable
            >
              <el-option
                v-for="item in countries"
                :key="item.iso2"
                :label="item.nombre.es"
                :value="item.iso2"
              >
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item class="input-class" prop="paisDestino">
          <div class="row">
            <el-select
              multiple
              class="col"
              v-model="localValue.paisDestino"
              collapse-tags
              placeholder="País destino"
              filterable
            >
              <el-option
                v-for="item in countries"
                :key="item.iso2"
                :label="item.nombre.es"
                :value="item.iso2"
              >
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item align="right">
          <el-button type="primary" @click="search()">Buscar</el-button>
          <el-button @click="clearFilters()">Limpiar</el-button>
        </el-form-item>
      </el-form>
    </template>
  </filter-base>
</template>
<script>
import FilterBase from "src/components/FilterBase.vue";
export default {
  components: { FilterBase },
  props: {
    value: {
      required: true,
      default: () => {
        return {
          codigoPostalOrigen: "",
          codigoPostalDestino: "",
          paisOrigen: [],
          paisDestino: [],
        };
      },
    },
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  mounted() {},
  computed: {
    countries() {
      return this.$store.state.geoname.paises.data;
    },
  },
  methods: {
    clearFilters() {
      this.localValue = {
        codigoPostalOrigen: "",
        codigoPostalDestino: "",
        paisOrigen: [],
        paisDestino: [],
      };
      this.$emit("onFilterChange", this.localValue);
      this.closeFiltro();
    },
    search() {
      this.$emit("onFilterChange", this.localValue);
      this.closeFiltro();
    },
    closeFiltro() {
      this.$refs.filtroBase.closeFiltro();
    },
  },
  watch: {
    localValue(newValue) {
      this.$emit("input", newValue);
    },
    value(newValue) {
      this.localValue = newValue;
    },
  },
};
</script>
